const config = {
    baseUrl: '',
    // baseUrl: 'https://homehuntdelivery.com',
    // baseUrl: 'http://localhost:3000',
    projectName: "Home Hunt Delivery",
    googleMapAPIKey: "AIzaSyC9EMEuAaH1UKQNS3h1RBL84LjeNQgPI98",
    mapZoom: 15,
    defaultLatLng: {
        lat: 41.492224,
        lng: -81.785381
    }
}
export default config;